import { render, staticRenderFns } from "./examHeader.vue?vue&type=template&id=2aa171b3&scoped=true"
import script from "./examHeader.vue?vue&type=script&lang=js"
export * from "./examHeader.vue?vue&type=script&lang=js"
import style0 from "./examHeader.vue?vue&type=style&index=0&id=2aa171b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa171b3",
  null
  
)

export default component.exports